import { slicedToArray as _slicedToArray, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { hex2RGBA } from './hexToRgba.mjs';

var DEFAULT_EMPTY_VALUE_COLOR_SET = {
  fog10: "",
  fog50: "",
  fog100: "",
  fog200: "",
  fog300: "",
  fog400: "",
  fog500: "",
  fog600: "",
  fog700: "",
  fog800: "",
  fog900: "",
  fog1000: "",
  grey10: "",
  grey50: "",
  grey100: "",
  grey200: "",
  grey300: "",
  grey400: "",
  grey500: "",
  grey600: "",
  grey700: "",
  grey800: "",
  grey900: "",
  grey1000: "",
  text: "",
  white10: "",
  white50: "",
  white100: "",
  white200: "",
  white300: "",
  white400: "",
  white500: "",
  white600: "",
  white700: "",
  white800: "",
  white900: "",
  white1000: ""
};
function getColorSetWithRgbaConvert(colorSet) {
  return Object.entries(colorSet || {}).reduce(function (result, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return Object.assign(Object.assign({}, result), _defineProperty({}, key, hex2RGBA(value)));
  }, DEFAULT_EMPTY_VALUE_COLOR_SET);
}

export { getColorSetWithRgbaConvert as default };
